import { useEffect } from "react"

declare global {
  interface Window {
    __swimminglySupportWidgetsInitialized?: boolean
  }
}

/**
 * Loads HubSpot and the Expertise AI chat widget only after the
 * authenticated shell is mounted (i.e. inside /app). This keeps
 * login/public routes lighter while preserving full functionality
 * for logged-in users.
 */
export default function SupportWidgets() {
  useEffect(() => {
    if (typeof document === "undefined" || typeof window === "undefined") return
    if (process.env.NODE_ENV === "development") return
    if (window.__swimminglySupportWidgetsInitialized) return

    window.__swimminglySupportWidgetsInitialized = true

    // HubSpot loader
    if (!document.getElementById("hs-script-loader")) {
      const hubspotScript = document.createElement("script")
      hubspotScript.type = "text/javascript"
      hubspotScript.id = "hs-script-loader"
      hubspotScript.async = true
      hubspotScript.defer = true
      hubspotScript.src = "//js.hs-scripts.com/20655551.js"
      document.body.appendChild(hubspotScript)
    }

    // Expertise AI chat-bot custom element
    if (!document.querySelector("chat-bot")) {
      const chatBot = document.createElement("chat-bot") as HTMLElement & {
        platform_id?: string
        user_id?: string
        chatbot_id?: string
      }

      chatBot.setAttribute("platform_id", "0fd78368-f41b-4b91-b038-9a739725c35e")
      chatBot.setAttribute("user_id", "f69b3e0b-11cd-4879-b257-bd4e15bc3d1c")
      chatBot.setAttribute("chatbot_id", "b50f2199-3a79-4a53-af75-dab691e21317")

      document.body.appendChild(chatBot)
    }

    // Chat widget loader script
    if (!document.querySelector('script[data-expertise-chat-bot="1"]')) {
      const chatScript = document.createElement("script")
      chatScript.src = "https://cdn.expertise.ai/chat-bot-loader.js"
      chatScript.defer = true
      chatScript.setAttribute("data-expertise-chat-bot", "1")
      document.body.appendChild(chatScript)
    }
  }, [])

  return null
}
